import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

var _baustein$register;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/** @module components/lyst-app */
import baustein from "baustein";
import _each from "lodash/each";
import _debounce from "lodash/debounce";
import { watchState } from "web/redux/state-watcher";
import analytics from "web/script/analytics/analytics";
import facebookEvents from "web/script/analytics/facebook-events";
import { events as calloutEvents } from "web/script/components/app-header-callout-classic";
import ProductOverlay from "web/script/components/overlays/product-overlay";
import ShippingAndReturnsOverlay from "web/script/components/overlays/shipping-and-returns-overlay";
import environment from "web/script/modules/environment";
import globals from "web/script/modules/globals";
import requester from "web/script/modules/requester";
import Stack from "web/script/modules/stack";
import { getProductPageRegex } from "web/script/routing/routes";
import alerts from "web/script/utils/alerts";
import browser from "web/script/utils/browser";
import globalEvents from "web/script/utils/global-events";
import history from "web/script/utils/history";
import logging from "web/script/utils/logging";
import url from "web/script/utils/url";
import "web/script/components/background-banner";
import "web/script/components/layouts/default-layout"; // Footer

import "web/script/components/tracked-link";
var LYST_APP_CALLOUT_SHOWN_MODIFIER = "lyst-app--callout-shown";
var LAYOUT_CONTAINER_SELECTOR = ".lyst-app__layout-container";
var LAYOUT_CONTAINER_DIMMED_MODIFIER = "lyst-app__layout-container--dimmed";
var LAYOUT_MATTE_SELECTOR = ".lyst-app__matte";
var APP_HEADER_COMPONENT = "app-header";
/**
 * This component encapsulates the entire lyst web app. It handles page load set up, any
 * subsequent client side navigation, and ideally also will manage the lifecycle of overlays.
 * @constructor
 * @alias module:components/lyst-app
 * @extends module:baustein
 */

export default baustein.register("lyst-app", (_baustein$register = {
  defaultOptions: {
    surveyEnabled: false,
    exitOverlaySource: "",
    exitOverlayUrl: ""
  },
  overlays: ["base-overlay", "country-overlay", "editing-overlay", "product-overlay"],
  membershipPages: ["sign_in", "new_signup", "signup", "signup form"],
  setupEvents: function setupEvents(add) {
    var _this = this;

    add("overlayOpen", this._onOverlayOpen);
    add("overlayCloseIntent", this._onOverlayCloseIntent);
    add("overlayClose", this._onOverlayClose);
    add("searchOpened", this.onSearchOpen);
    add("searchClosed", this.onSearchClose);
    add("addedToBag", this.openCartCallout);
    add("appHeaderUpdatedOffset", this.onHeaderUpdatedOffset);
    add("desktopHeaderUpdatedOffset", this.onHeaderUpdatedOffset);
    add("oosItemFound", "cart-summary", this.onCartCalloutOpened);
    add("saveForLaterButtonInserted", this._onSaveForLaterButtonInserted);
    add("cartSummaryShown", this.closeSaveForLaterCallout);
    add("showCsaUnit", this.showCsaUnit);
    add("showCsaShoppingUnit", this.showCsaShoppingUnit);
    add("fixPageContent", this.fixPageContent);
    add("unFixPageContent", this.unFixPageContent);
    add("showInstantFeedback", this.showInstantFeedback);
    add("click", LAYOUT_MATTE_SELECTOR, this.onLayoutMatteClick);
    ["appHeaderMenuOpened", "appHeaderAutoCompleteOpened", calloutEvents.OPEN_LYST_MATTE].forEach(function (e) {
      return add(e, _this.addLayoutMatteAndBlockScroll);
    });
    add(calloutEvents.OPEN_LYST_MATTE_WITH_SCROLL, this.addLayoutMatte);
    ["appHeaderMenuClosed", "appHeaderAutoCompleteClosed", calloutEvents.CLOSE_LYST_MATTE].forEach(function (e) {
      return add(e, _this.removeLayoutMatte);
    });
  },
  init: function init() {
    this.attachShippingOverlayWatcher();
    this.attachAppHeaderCartWatcher();
    this.crmSurveyOverlay;
    this.overlayStack = new Stack();
    this.sflProductIdsQueue = [];

    if (environment.get("facebookEvent")) {
      // we have a facebook page event to send
      this._trackFacebookEvent();
    }

    this._trackPWAAppInstallEvent();

    this._trackPWAHomescreenLaunch();

    this._trackPWAMode();

    this._performFrontEndRouting();

    this._redirectProxySites();
  },
  onInsert: function onInsert() {
    this._addSupportClasses(); // these are messages created using the Django messages framework
    // See https://docs.djangoproject.com/en/1.8/ref/contrib/messages/ for more info


    _each(environment.get("messages"), alerts.alert);

    var parsedURL = url.parse(globals.window.location); // show instant notification if registered = "true" and area are set

    var notificationArea = parsedURL.searchParams.get("area");

    if ((parsedURL.searchParams.get("loggedin") === "true" || parsedURL.searchParams.get("registered") === "true") && notificationArea) {
      this.showInstantFeedback({
        area: notificationArea
      });
    } // fire stock check on page load


    var header = this.findComponent(APP_HEADER_COMPONENT);

    if (header) {
      var cartButton = header.findComponent("app-header-cart");

      if (cartButton) {
        cartButton.checkStock();
      }

      var stickyBuyButton = this.findComponent("buybuybuy-sticky-buy-button");

      if (stickyBuyButton) {
        stickyBuyButton.setHeaderHeightReference(header.el.getBoundingClientRect().height);
      }
    }
  },
  onRemove: function onRemove() {
    this.releaseGlobalHandler("mouseleave", this.onBodyMouseLeave);
  },

  /**
   * Block the scrolling of the body.
   */
  blockScrolling: function blockScrolling() {
    this.el.classList.add("no-scroll");
  },

  /**
   * Un-block the scrolling of the body.
   */
  unblockScrolling: function unblockScrolling() {
    this.el.classList.remove("no-scroll");
  },

  /**
   * A function to reference when we want to prevent a default browser behaviour
   * @param {Event} event
   */
  preventDefault: function preventDefault(event) {
    event.preventDefault();
    return false;
  },
  fixPageContent: function fixPageContent() {
    this.el.classList.add("fix-element");
  },
  unFixPageContent: function unFixPageContent() {
    this.el.classList.remove("fix-element");
  },

  /**
   * Tracks Facebook events.
   * @private
   */
  _trackFacebookEvent: function _trackFacebookEvent() {
    var event = environment.get("facebookEvent");
    analytics.tagEvent(analytics.TAG_NETWORKS.FACEBOOK, facebookEvents[event]);
  },

  /**
   * Tracks PWA appinstalled event.
   * @private
   */
  _trackPWAAppInstallEvent: function _trackPWAAppInstallEvent() {
    window.addEventListener("appinstalled", function () {
      analytics.event("pwa", "installed");
    });
  },

  /**
   * Tracks if user launched PWA from homescreen
   * @private
   */
  _trackPWAHomescreenLaunch: function _trackPWAHomescreenLaunch() {
    var params = this._getParamsFromRequest();

    if (params.get("utm_medium") === "pwa") {
      analytics.event("pwa", "homescreen_launch");
    }
  },

  /**
   * Tracks if user is currently in PWA
   * @private
   */
  _trackPWAMode: function _trackPWAMode() {
    var isPWAinBrowser = true;

    if (matchMedia("(display-mode: standalone)").matches) {
      // Android and iOS 11.3+
      isPWAinBrowser = false;
    } else if ("standalone" in navigator) {
      // useful for iOS < 11.3
      isPWAinBrowser = !navigator.standalone;
    }

    if (!isPWAinBrowser) {
      analytics.event("pwa", "is_pwa");
    }
  },

  /**
   * If the page is being loaded on a non-lyst domain, redirect back to Lyst.
   * @private
   */
  _redirectProxySites: function _redirectProxySites() {
    // Attempt to guess if this is an allowed domain.
    var hostname = document.location.hostname;
    var href = document.location.href;
    var hostWhitelist = /(lyst|127\.0\.0\.1|localhost|archive\.org|google)/;
    var hrefWhitelist = /translate.*\/.*\?.*=.*lyst/;

    if (hostname.match(hostWhitelist) || href.match(hrefWhitelist)) {
      return;
    } else {
      document.location.href = "https://www.lyst.com".concat(document.location.pathname, "?nonlystdomainredirect=1");
    }
  },
  _getParamsFromRequest: function _getParamsFromRequest() {
    var parsed = url.parse(globals.window.location.href);
    return parsed.searchParams;
  },

  /**
   * Adds classes to this component that indicate whether certain
   * features are supported or not.
   * @private
   */
  _addSupportClasses: function _addSupportClasses() {
    var classList = this.el.classList; // add class to the body to indicate whether this device has touch support

    classList.add(browser.hasTouch ? "has-touch" : "no-touch"); // if device supports css transforms add class to body for CSS to hook into

    classList.toggle("has-css-transforms", browser.supportsCSSTransforms); // if device has css transitions

    classList.toggle("no-css-transitions", !browser.supportsCSSTransitions); // If scrollbars are stylable, add a class to help.

    classList.toggle("css-scrollbars", browser.supportsCSSScrollbars);
  },
  getLayoutContainer: function getLayoutContainer() {
    return this.el.querySelector(LAYOUT_CONTAINER_SELECTOR);
  },
  hideContent: function hideContent() {
    this.getLayoutContainer().classList.add("hidden");
    this.el.querySelector(".background-banner-wrapper").classList.add("hidden");
  },
  showContent: function showContent() {
    this.getLayoutContainer().classList.remove("hidden");
    this.el.querySelector(".background-banner-wrapper").classList.remove("hidden");
  },
  openCartCallout: function openCartCallout() {
    // Increment cart button item count by 1
    globalEvents.trigger("cart.change", {
      itemCountDifference: 1
    });
    var header = this.findComponent(APP_HEADER_COMPONENT);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = header.findComponents("app-header-cart")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var cartButton = _step.value;
        // show cart callout
        cartButton.showCartCallout();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    analytics.event("header", "show-cart-callout", null, true);
    this.onCartCalloutOpened();
  },
  onCartCalloutOpened: function onCartCalloutOpened() {
    // show desktop header, add matte, prevent scrolling
    this.invoke(this.findComponent("desktop-header"), "show");
    this.addLayoutMatteAndBlockScroll();
    this.el.classList.add(LYST_APP_CALLOUT_SHOWN_MODIFIER); // close existing callouts

    this.closeSaveForLaterCallout();
  },
  onHeaderUpdatedOffset: function onHeaderUpdatedOffset(event) {
    var offset = event.offset;
    var stickyBuyButton = this.findComponent("buybuybuy-sticky-buy-button");

    if (stickyBuyButton) {
      stickyBuyButton.updatePosition(offset);
    }
  },
  onSearchOpen: function onSearchOpen() {
    this.getLayoutContainer().classList.add("hidden");
    this.el.classList.add("lyst-app--full-height");
  },
  onSearchClose: function onSearchClose() {
    this.getLayoutContainer().classList.remove("hidden");
    this.el.classList.remove("lyst-app--full-height");
  },
  closeSaveForLaterCallout: function closeSaveForLaterCallout() {
    var header = this.findComponent(APP_HEADER_COMPONENT);

    if (!header) {
      return;
    }

    var saveForLaterComponent = header.findComponent("save-for-later-callout");

    if (saveForLaterComponent) {
      saveForLaterComponent.destroy();
    }
  },
  closeCartSummary: function closeCartSummary() {
    var header = this.findComponent(APP_HEADER_COMPONENT);

    if (header) {
      var cartSummary = header.findComponent("cart-summary");
      this.invoke(cartSummary, "close");
    }
  },
  addLayoutMatte: function addLayoutMatte() {
    var lystAppContainer = this.getLayoutContainer();

    if (lystAppContainer) {
      lystAppContainer.classList.add(LAYOUT_CONTAINER_DIMMED_MODIFIER);
    }

    this.closeSaveForLaterCallout();
  },
  removeLayoutMatte: function removeLayoutMatte() {
    var lystAppContainer = this.getLayoutContainer();

    if (lystAppContainer) {
      lystAppContainer.classList.remove(LAYOUT_CONTAINER_DIMMED_MODIFIER);
    }

    this.unblockScrolling();
  },
  addLayoutMatteAndBlockScroll: function addLayoutMatteAndBlockScroll() {
    this.addLayoutMatte();
    this.blockScrolling();
  },
  _onOverlayOpen: function _onOverlayOpen(event) {
    this.overlayStack.push(event.target);
    this.blockScrolling();
  },
  _onOverlayCloseIntent: function _onOverlayCloseIntent(event) {
    var activeOverlay = this.overlayStack.peek(); // If the event is not coming from the active
    // overlay, preventDefault and do nothing.

    if (activeOverlay !== event.target) {
      event.preventDefault();
      return;
    }
  },
  _onOverlayClose: function _onOverlayClose() {
    var header = this.findComponent("app-header");
    this.overlayStack.pop(); // If there is no active overlay,
    // unblock the scrolling

    if (this.overlayStack.isEmpty()) {
      if (header && header.openCallouts) {
        return;
      }

      this.unblockScrolling();
      this.unFixPageContent();
    }
  }
}, _defineProperty(_baustein$register, "closeSaveForLaterCallout", function closeSaveForLaterCallout() {
  var callout = this.findComponent("save-for-later-callout");

  if (callout) {
    callout.destroy();
  }
}), _defineProperty(_baustein$register, "_onSaveForLaterButtonInserted", function _onSaveForLaterButtonInserted(event) {
  this.sflProductIdsQueue.push(event.productId);

  this._fetchSaveForLaterPins();
}), _defineProperty(_baustein$register, "_fetchSaveForLaterPins", _debounce(function () {
  var _this2 = this;

  var endpoint = "/services/pins/";
  var query = url.toURLSearchParams({
    product_id: _toConsumableArray(this.sflProductIdsQueue)
  });
  this.sflProductIdsQueue = [];
  requester.get(endpoint, query).then(function (data) {
    _this2._setPinnedProducts(data.pin_mapping);
  }).catch(function (error) {
    return logging.error(error);
  });
}, 50)), _defineProperty(_baustein$register, "_setPinnedProducts", function _setPinnedProducts(pinnedProductsMapping) {
  var sflButtons = this.findComponents("save-for-later-button");
  sflButtons.forEach(function (saveForLaterButton) {
    var isPinned = pinnedProductsMapping[saveForLaterButton.options.productId];

    if (isPinned) {
      saveForLaterButton._render(true);
    }
  });
}), _defineProperty(_baustein$register, "showCsaUnit", function showCsaUnit(event) {
  var position = event["position"];
  var csaContainers = this.findComponents("adsense-custom-search-ads");
  csaContainers.forEach(function (csaContainer) {
    if (csaContainer.options.dataPosition == position) {
      csaContainer.createCsaUnit();
    }
  });
}), _defineProperty(_baustein$register, "showCsaShoppingUnit", function showCsaShoppingUnit(event) {
  var position = event["position"];
  var csaContainers = this.findComponents("adsense-custom-search-ads");
  csaContainers.forEach(function (csaContainer) {
    if (csaContainer.options.dataPosition == position) {
      csaContainer.createCsaShoppingUnit();
    }
  });
}), _defineProperty(_baustein$register, "onLayoutMatteClick", function onLayoutMatteClick() {
  this.removeLayoutMatte();
  var savedSearchCreatorComponent = this.findComponent("saved-search-creator");

  if (savedSearchCreatorComponent) {
    savedSearchCreatorComponent.closeDropDownsAndBlurElements();
  }
}), _defineProperty(_baustein$register, "showInstantFeedback", function showInstantFeedback(_ref) {
  var area = _ref.area;
  this.findComponents("instant-feedback").forEach(function (component) {
    if (component.options.area === area) {
      component.show();
    }
  });
}), _defineProperty(_baustein$register, "attachAppHeaderCartWatcher", function attachAppHeaderCartWatcher() {
  var _this3 = this;

  watchState(function (state) {
    return state.appHeaderCartReducer;
  }, function () {
    _this3.openCartCallout();
  });
}), _defineProperty(_baustein$register, "attachShippingOverlayWatcher", function attachShippingOverlayWatcher() {
  watchState(function (state) {
    return state.shippingAndReturnsOverlayReducer;
  }, function (overlayState) {
    if (!overlayState.open) {
      return;
    }

    var linkId = overlayState.linkId;
    var shippingAndReturnsOverlay = new ShippingAndReturnsOverlay({
      linkId: linkId
    }); // append overlay to the document body, because this component will typically
    // be shown in an accordion, which is position relative and overflow hidden
    // so would not display correctly

    shippingAndReturnsOverlay.appendTo(document.body);
    shippingAndReturnsOverlay.open();
    analytics.event("buy_area", "show_shipping_and_returns");
  });
}), _defineProperty(_baustein$register, "_performFrontEndRouting", function _performFrontEndRouting() {
  history.on("change", this._onHistoryChange.bind(this));
}), _defineProperty(_baustein$register, "_openProductOverlay", function () {
  var _openProductOverlay2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref2) {
    var newURL, pathname, searchParams, _pathname$match, _pathname$match2, productSlug, args, existingOverlay, overlay;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            newURL = _ref2.newURL;
            pathname = newURL.pathname, searchParams = newURL.searchParams;
            _pathname$match = pathname.match(getProductPageRegex()), _pathname$match2 = _slicedToArray(_pathname$match, 3), productSlug = _pathname$match2[2];
            args = {
              productSlug: productSlug,
              // TODO: These were always undefined before, is fixing them correct?
              productUid: searchParams.get("product_overlay_uid"),
              linkId: searchParams.get("link_id")
            };
            existingOverlay = this.findComponent("product-overlay");

            if (!existingOverlay) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", existingOverlay.updateOptions(args));

          case 7:
            // NOTE: Change this to an `import()` statement to bundle split the overlay
            overlay = new ProductOverlay(args);
            overlay.appendTo(this);
            return _context.abrupt("return", overlay.open());

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function _openProductOverlay(_x) {
    return _openProductOverlay2.apply(this, arguments);
  }

  return _openProductOverlay;
}()), _defineProperty(_baustein$register, "_onHistoryChange", function () {
  var _onHistoryChange2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(_, data) {
    var _data$oldURL, _data$oldURL2;

    var sendPageView, productPageRoute, path, overlay, feedLayout;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            sendPageView = function _ref3() {
              if (data.eventType != "popstate") {
                analytics.pageView();
              }
            };

            if (!(data.newURL.pathname == ((_data$oldURL = data.oldURL) === null || _data$oldURL === void 0 ? void 0 : _data$oldURL.pathname) && data.queryChanges.length == 0)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            productPageRoute = getProductPageRegex();
            path = data.newURL.pathname;

            if (!productPageRoute.test(path)) {
              _context2.next = 13;
              break;
            }

            if (!this.findComponent("product-page")) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return");

          case 8:
            _context2.next = 10;
            return this._openProductOverlay(data);

          case 10:
            sendPageView();
            _context2.next = 31;
            break;

          case 13:
            if (!productPageRoute.test((_data$oldURL2 = data.oldURL) === null || _data$oldURL2 === void 0 ? void 0 : _data$oldURL2.pathname)) {
              _context2.next = 23;
              break;
            }

            // Leaving a product page URL
            // This should only ever happen when you close an overlay.
            overlay = this.findComponent("product-overlay");

            if (overlay) {
              _context2.next = 19;
              break;
            }

            // "this should never happen"
            logging.error("Unexpected product transition to ".concat(path, "?!")); // The router's default "halp" reaction is to reload the page, so

            globals.window.location.reload();
            return _context2.abrupt("return");

          case 19:
            _context2.next = 21;
            return overlay.close();

          case 21:
            _context2.next = 31;
            break;

          case 23:
            feedLayout = this.findComponent("product-feed-layout");

            if (feedLayout) {
              _context2.next = 28;
              break;
            }

            // "this really should never happen"
            logging.error("Unexpected page transition to ".concat(path, "?!")); // fallback

            globals.window.location.reload();
            return _context2.abrupt("return");

          case 28:
            _context2.next = 30;
            return feedLayout.onFilterUpdate(_, data);

          case 30:
            sendPageView();

          case 31:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  function _onHistoryChange(_x2, _x3) {
    return _onHistoryChange2.apply(this, arguments);
  }

  return _onHistoryChange;
}()), _baustein$register));